/**
 * PATH: packages/email-hub/src/feature/email-layout/EmailLayoutFrame.tsx
 * FILE_ID: EMAIL-LAYOUT-FRAME-001
 * PURPOSE: Thin frame assembling Email navigation, routed content, and overlays.
 */

import { cn } from '../../_internal/lib/utils'
import IntegrationEventsPanel from '../components/IntegrationEventsPanel'
import { OfflinePill } from '../components/OfflinePill'
import { ConnectedMailboxesPopover } from './ConnectedMailboxesPopover'
import { EmailBottomDock } from './EmailBottomDock'
import { EmailContent } from './EmailContent'
import { EmailSidebar } from './EmailSidebar'
import { useEmailLayoutController } from './useEmailLayoutController'

export function EmailLayoutFrame() {
  const layout = useEmailLayoutController()

  return (
    <div
      className={cn(
        'flex min-h-0 relative',
        layout.useBottomNav ? 'flex-col h-full' : 'h-full',
      )}
    >
      <OfflinePill />
      {layout.isNarrow && layout.mobileNavOpen && (
        <button
          type="button"
          onClick={() => layout.setMobileNavOpen(false)}
          className="fixed inset-0 z-50 bg-black/40 backdrop-blur-sm"
          aria-label="Close Email navigation"
        />
      )}
      <EmailSidebar layout={layout} />
      <EmailContent layout={layout} />
      <EmailBottomDock layout={layout} />
      <ConnectedMailboxesPopover layout={layout} />
      <IntegrationEventsPanel
        open={layout.issuesOpen}
        onClose={() => layout.setIssuesOpen(false)}
      />
    </div>
  )
}
